import { render, staticRenderFns } from "./TextTabsHeader.vue?vue&type=template&id=59bd02c9&scoped=true&"
import script from "./TextTabsHeader.vue?vue&type=script&lang=js&"
export * from "./TextTabsHeader.vue?vue&type=script&lang=js&"
import style0 from "./TextTabsHeader.vue?vue&type=style&index=0&id=59bd02c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bd02c9",
  null
  
)

export default component.exports